import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { getLocalAuthToken } from "../services/apiClient";

export default function AdminRoute({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-gray-600">
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== "admin") {
    return <Navigate to="/home" replace />;
  }

  // Administrator accounts MUST possess a valid 2FA-verified local session token.
  // Sessions without this token (such as unverified Cognito sessions) are blocked.
  if (!getLocalAuthToken()) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          error:
            "Administrator accounts require mandatory 2-step verification. Please sign in to access the administrator portal.",
        }}
      />
    );
  }

  return <>{children}</>;
}
